module.exports = __webpack_public_path__ + "static/media/users.3cc8b117.svg";